import React, { memo } from 'react';
import PropTypes from 'prop-types';

import TimeFilterChip from '../chips/time';

import { useDataTypeFilterHandleChange, useDefaultTimeOptions } from '../hooks';

const TimeFilter = ({filter, value, dataType, subType, filterKey}) => {
  const handleChange = useDataTypeFilterHandleChange(dataType, subType, filterKey);
  const options = useDefaultTimeOptions();

  return (
    <TimeFilterChip
      label={filter.label || 'Time'}
      timeOptions={options}
      timeValues={value}
      onChange={handleChange}
    />
  );
};

TimeFilter.propTypes = {
  dataType: PropTypes.string.isRequired,
  filter: PropTypes.object.isRequired,
  filterKey: PropTypes.string.isRequired,
  subType: PropTypes.string,
  value: PropTypes.object
};

export default memo(TimeFilter);
